// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3cQh_","subheader":"ReorderModal_subheader__tZDIE","listWrap":"ReorderModal_listWrap__3T1s1"};